import { useState } from 'react';
import { FormTextInputV2 } from '@wajeez-web/components/form-builder';
import { ButtonHeadless, Modal } from '@wajeez-web/components/ui';
import { Server } from '@wajeez-web/core/api-base';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BiLoaderAlt } from 'react-icons/bi';
import { CheckboxGroup } from '@wajeez-web/components/mui';

interface CloneModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
  onSaveAndEdit: (name: string) => Promise<void>;
  isLoading: boolean;
  title?: string;
}

type Input = {
  name: string;
};

export const CloneModal = ({
  isOpen,
  onClose,
  onSave,
  onSaveAndEdit,
  title,
  isLoading,
}: CloneModalProps) => {
  const [isSaveAndEdit, setIsSaveAndEdit] = useState(false);

  const { control, handleSubmit } = useForm<Input>();

  const onFormSubmit: SubmitHandler<Input> = async (data) => {
    if (isSaveAndEdit) {
      await onSaveAndEdit(data.name);
    } else {
      await onSave(data.name);
    }
  };

  return (
    <Modal
      title={title || 'Clone'}
      withScroll={false}
      open={isOpen}
      onClose={onClose}
      handleAlert={false}
      fontClassName="font-[Tajawal]"
    >
      <div className="font-[Tajawal]">
        <form
          onSubmit={handleSubmit(onFormSubmit)}
          className="w-full flex flex-col justify-start items-start"
          noValidate
        >
          <div className="w-[300px]">
            <FormTextInputV2
              control={control}
              name="name"
              fieldMeta={{
                fieldType: Server.FieldType.Text,
                required: true,
                label: 'Name',
                placeHolder: 'Name',
                fieldOptions: {},
              }}
            />
          </div>
          <div className="mt-2">
            <CheckboxGroup
              data={[
                {
                  value: 'edit',
                  label: 'Open the edit page after saving',
                  selected: false,
                },
              ]}
              onChange={(selection) => {
                setIsSaveAndEdit(Boolean(selection?.[0].selected));
              }}
            />
          </div>
          <div className="mt-6 w-full flex justify-end items-center">
            <div className="w-[90px]">
              <ButtonHeadless
                type="submit"
                paddingYStyle="py-1"
                borderRadiusStyle="rounded-[6px]"
              >
                <div className="w-full flex justify-center items-center text-white text-[16px] font-medium">
                  <ReturnTranslatedText
                    origintext="Save"
                    text={`buttons.${'Save'}`}
                  />
                  {isLoading && (
                    <BiLoaderAlt className="mr-2 animate-spin w-5" />
                  )}
                </div>
              </ButtonHeadless>
            </div>
            <div className="w-[90px] mr-4">
              <ButtonHeadless
                paddingYStyle="py-1"
                bgStyle="bg-warmGray-300"
                borderRadiusStyle="rounded-[6px]"
                action={onClose}
              >
                <div className="w-full flex justify-center items-center text-warmGray-500 text-[16px] font-bold">
                  <ReturnTranslatedText
                    origintext="Cancel"
                    text={`buttons.${'Cancel'}`}
                  />
                </div>
              </ButtonHeadless>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
